export const GET_ALL_SETTINGS = "GET_ALL_SETTINGS";
export const GET_ALL_SETTINGS_SUCCESS = "GET_ALL_SETTINGS_SUCCESS";
export const GET_ALL_SETTINGS_FAILURE = "GET_ALL_SETTINGS_FAILURE";

export const EDIT_SETTINGS = "EDIT_SETTINGS";
export const EDIT_SETTINGS_SUCCESS = "EDIT_SETTINGS_SUCCESS";
export const EDIT_SETTINGS_FAILURE = "EDIT_SETTINGS_FAILURE";

export const GET_TAXNUMBER = "GET_TAXNUMBER";
export const GET_TAXNUMBER_SUCCESS = "GET_TAXNUMBER_SUCCESS";
export const GET_TAXNUMBER_FAILURE = "GET_TAXNUMBER_FAILURE";

export const EDIT_TAXNUMBER = "EDIT_TAXNUMBER";
export const EDIT_TAXNUMBER_SUCCESS = "EDIT_TAXNUMBER_SUCCESS";
export const EDIT_TAXNUMBER_FAILURE = "EDIT_TAXNUMBER_FAILURE";

export const GET_IDENTITY = "GET_IDENTITY";
export const GET_IDENTITY_SUCCESS = "GET_IDENTITY_SUCCESS";
export const GET_IDENTITY_FAILURE = "GET_IDENTITY_FAILURE";

export const SUBMIT_IDENTITY = "SUBMIT_IDENTITY";
export const SUBMIT_IDENTITY_SUCCESS = "SUBMIT_IDENTITY_SUCCESS";
export const SUBMIT_IDENTITY_FAILURE = "SUBMIT_IDENTITY_FAILURE";
